import { EditDocument } from '../../components/Library';

const DocumentDetail = () => <EditDocument />;

export default DocumentDetail;
